import React from 'react';
import { Foto, Cargando, ErrorCarga } from './Comunes.jsx';
import { clp } from '../utiles/fechas.js';

export function Home({ sedes, go }) {
  return (
    <>
      <div className="wrap">
        <div className="hero">
          <div className="eyebrow">Balancea tu sistema nervioso</div>
          <h1>Reserva tu momento de <em>calma</em></h1>
          <p>
            Elige tu centro TUNE, escoge el horario que más te acomode y reserva en
            segundos. Pagas en el centro.
          </p>
        </div>

        <div className="section-lead">Elige tu centro</div>

        {sedes.cargando ? <Cargando /> : null}
        {sedes.error ? <ErrorCarga error={sedes.error} reintentar={sedes.recargar} /> : null}

        {sedes.datos && sedes.datos.length === 0 ? (
          <div className="slots-empty">Todavía no hay centros disponibles.</div>
        ) : null}

        <div className="sede-grid">
          {(sedes.datos || []).map((s) => (
            <div key={s.id} className="sede-card" onClick={() => go('sede', s.id)}>
              <Foto url={s.fotos[0]} cls="sede-photo" label={s.comuna} />
              <div className="sede-body">
                <div className="sede-name">{s.nombre}</div>
                <div className="sede-dir">{s.direccion}</div>
                <div className="sede-foot">
                  <div className="sede-price">{clp(s.precio_tune)} <small>/ sesión</small></div>
                  <div className="sede-go">Reservar ›</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="foot">TUNE · Wellness as a Service · pagas en el centro</div>
    </>
  );
}
